export const SHOW_MODAL = "SHOW_MODAL";
export const HIDE_MODAL = "HIDE_MODAL";
export const OPEN_BROADCAST_SUMMARY = "OPEN_BROADCAST_SUMMARY";
export const CLOSE_BROADCAST_SUMMARY = "CLOSE_BROADCAST_SUMMARY";
